import { css } from '@emotion/core'
import styled from '@emotion/styled'
import { FontNormal } from '@css/fonts'
import { fontSize } from '@css/styles'
import {
  darkRed,
  MQ,
} from '@css/constants'

export const ErrorText = styled('div')(css`
  ${FontNormal(600)};
  color: ${darkRed};
  text-align: center;
`)

export const QuestionFormWrapper = styled('form')(css`
  max-width: 275px;
  margin: 22px auto 0;

  & > ${ErrorText} {
    margin-top: 10px;
  }
`)

export const QuestionContainer = styled('div')(css`
  margin-top: 14px;
`)

export const Label = styled('div')(css`
  ${FontNormal(500)};
  ${fontSize(16)};
  margin-left: -40px;
  margin-right: -40px;
  text-align: center;
  padding-bottom: 15px;

  & sup {
    ${FontNormal(600)};
    ${fontSize(11)};
    position: relative;
    bottom: 6px;
    vertical-align: baseline;
  }

  ${MQ.SMALL_SCREENS} {
    margin-left: 0;
    margin-right: 0;
  }
`)

export const submitBtnStyles = css`
  max-width: 275px;
  width: 100%;
  margin-top: 12px;
  white-space: initial;
  padding-left: 5px;
  padding-right: 5px;
  text-align: center;
`
